import { yupResolver } from "@hookform/resolvers/yup"
import React, { useState, useEffect } from "react"
import { FormProvider, useForm } from "react-hook-form"
import {
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormFeedback,
  Spinner,
  Form,
  FormGroup,
  Label,
} from "reactstrap"
import * as yup from "yup"
import LoadingButton from "../../../components/Common/LoadingButton"
import { UFInput } from "../../../components/Common/Fields/Input"
import classnames from "classnames"
import closeIcon from "../../../assets/icons/close.svg"
import { Link } from "react-router-dom"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import { postFinanceAccounts } from "../../../services/finance/finance"
import FinanceCat from "../../../components/Common/chooseFields/financeCat"
import FinanceSubCatId from "../../../components/Common/chooseFields/financeSubCatId"
import AccountsType from "../../../components/Common/chooseFields/accountType"

const schema = yup.object().shape({
  name: yup.string().required("Description is Required"),
  category_id: yup.mixed().required("Category is Required"),
})

const Edit = ({ loading, onUpdate, id, error, close, ...props }) => {
  const [companyCheck, setIsCompanyCheck] = useState(false)
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
  })
  const methods = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    shouldFocusError: true,
  })
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (props?.editItem?.modal) {
      reset({
        ...props?.editItem?.value,
        category_id: {
          value: props?.editItem?.value?.category?.id,
          label: props?.editItem?.value?.category?.name,
        },
        subcategory_id: {
          value: props?.editItem?.value?.subcategory?.id,
          label: props?.editItem?.value?.subcategory?.name,
        },
        type: {
          value: props?.editItem?.value?.type?.name == "payable" ? 1 : 0,
          label:
            props?.editItem?.value?.type?.name == "payable"
              ? "payable"
              : "receivable",
        },
        is_company: setIsCompanyCheck(
          props?.editItem?.value?.is_company == 1 ? true : false
        ),
        name: props?.editItem?.value?.name,
      })
    }
  }, [props?.editItem?.modal])

  const handleRegistration = async data => {
    try {
      setIsLoading(true)
      const createdAccounts = await postFinanceAccounts({
        ...data,
        category_id: data?.category_id?.value,
        subcategory_id: data?.subcategory_id?.value,
        type: data?.type?.label,
        is_company: companyCheck == true ? 1 : 0,
        name: data?.name,
      })
      toastSuccess(createdAccounts?.message)
      onUpdate()
    } catch (err) {
      toastError(err?.message)
    } finally {
      setIsLoading(false)
      reset()
      close()
    }
  }

  const handleCompanyCheck = dt => {
    setIsCompanyCheck(!dt)
  }

  return (
    <>
      <ModalHeader className="custom-modal-header">
        <div className="d-flex justify-content-between">
          <h5>{props?.editItem?.modal ? "Edit Accounts" : "New Accounts"}</h5>{" "}
          <img
            src={closeIcon}
            alt=""
            onClick={close}
            width="10"
            role="button"
          />
        </div>
      </ModalHeader>
      {loading ? (
        <div
          className="px-8"
          style={{
            width: "100%",
            textAlign: "center",
            minHeight: "200px",
            paddingTop: "90px",
          }}
        >
          <Spinner
            className={classnames({
              "mx-2": true,
              "position-relative": true,
              visible: true,
            })}
            size="lg"
          />
        </div>
      ) : (
        <>
          <ModalBody>
            <FormProvider {...methods}>
              <Form id={`ev-form`} onSubmit={handleSubmit(handleRegistration)}>
                <Row>
                  <Col sm={12}>
                    <FormGroup className="mb-4">
                      <Label>
                        Category<span className="mandatory">*</span>
                      </Label>
                      <FinanceCat
                        control={control}
                        placeholder="Enter the Category"
                        name={"category_id"}
                        invalid={!!errors.category_id}
                      />
                      <FormFeedback invalid>
                        {errors.category_id?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col sm={12}>
                    <FormGroup className="mb-4">
                      <Label>
                        Sub Category<span className="mandatory">*</span>
                      </Label>
                      <FinanceSubCatId
                        control={control}
                        placeholder="Sub-Category"
                        name={"subcategory_id"}
                        invalid={!!errors.subcategory_id}
                        selectedCategory={watch("category_id")}
                      />
                      <FormFeedback invalid>
                        {errors.subcategory_id?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col sm={12}>
                    <FormGroup className="mb-4">
                      <Label>
                        Type<span className="mandatory">*</span>
                      </Label>
                      <AccountsType
                        control={control}
                        placeholder="Select"
                        name={"type"}
                        invalid={!!errors.type}
                      />
                      <FormFeedback invalid>
                        {errors.type?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col lg={12} onClick={() => handleCompanyCheck(companyCheck)}>
                    <FormGroup>
                      <input
                        type="checkbox"
                        className="ever-rise-checkbox"
                        name={"is_company"}
                        checked={companyCheck}
                      />
                      <Label className="ms-2">Is Company</Label>
                    </FormGroup>
                  </Col>
                  <Col sm={12}>
                    <FormGroup className="mb-4">
                      <Label>
                        Accounts<span className="mandatory">*</span>
                      </Label>
                      <UFInput
                        control={control}
                        placeholder="Enter the Accounts"
                        name={"name"}
                        invalid={!!errors.name}
                      />
                      <FormFeedback invalid>
                        {errors.name?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                </Row>
              </Form>
            </FormProvider>
          </ModalBody>
          <ModalFooter>
            <LoadingButton
              form={`ev-form`}
              color={"primary"}
              loading={isLoading}
              disabled={isLoading}
              type="submit"
            >
              {props?.editItem?.modal ? "Update" : "Save"}
            </LoadingButton>
          </ModalFooter>
        </>
      )}
    </>
  )
}

const EditAccounts = ({ buttonLabel, className, ...props }) => {
  const [modal, setModal] = useState(false)
  const toggle = () => setModal(!modal)

  useEffect(() => {
    if (props?.editItem?.modal) {
      toggle()
    }
  }, [props?.editItem?.modal])

  return (
    <>
      <Link to="#" className={className} onClick={toggle}>
        {buttonLabel}
      </Link>
      <Modal isOpen={modal} toggle={toggle} backdrop={"static"}>
        <Edit
          close={() => {
            setModal(false)
            props?.onReset()
          }}
          {...props}
        />
      </Modal>
    </>
  )
}

export default EditAccounts
